<template>
  <v-main>
    <DetailsDialog ref="dialog" @reload="$refs.report.reload()" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
      :rememberLastClick="true"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Novo teclado...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { Keyboard } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import DetailsDialog from './DetailsDialog.vue'
import { brDt } from 'oderon-commons/src/formatters.js'

export default {
  pageTitle: 'Teclados Checklist',
  components: {
    GenericReport,
    DetailsDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Teclados Checklist',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos',
            defVal: false
          }
        ]
      },
      adapterSpec: {
        defOrder: 'name asc',
        defCodes: [
          'id',
          'name',
          'serial',
          'orgName',
          'vehicleCode',
          'updatedAt'
        ],
        columns: [
          { t: 'ID|', w: 100, d: 'id', color: '#cccccc' },
          { t: 'Nome', d: 'name' },
          { t: 'Serial', d: 'serial' },
          { t: 'Lote', d: 'batchNumber' },
          { t: 'Organização', code: 'orgName', d: 'vehicle.org.label' },
          { t: 'Veículo', code: 'vehicleCode', d: 'vehicle.code' },
          { t: 'Descrição', code: 'description', d: 'description', selectable: true },
          { t: 'Atualizado em|', d: 'updatedAt', f: brDt, w: 250 },
          {
            t: 'Desativado em|',
            d: 'deletedAt',
            f: brDt,
            w: 250,
            selectable: true
          }
        ]
      },

      // checkboxes marcados
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.downloadCsv()
        }
      ]
    }
  },
  methods: {
    async fetchData({ keywords, includeInactive } = {}) {
      let { count, rows } = await Keyboard.findAll({
        keywords,
        includeInactive
      })
      return { count, rows }
    },

    async newRow() {
      let label = 'Digite o número de série do novo teclado (apenas dígitos)'
      let serial = await this.$prompt({ label })
      if (serial != null) {
        if (!serial.match(/^\d+/)) {
          this.$snack('O número deve ser composto apenas de dígitos', {
            color: 'red'
          })
          return
        }

        let row = await this.$loading(async () => {
          return Keyboard.save({
            serial: +serial,
            name: 'TO-' + serial.toString().padStart(3, '0')
          })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    },

    async selectRow({ row, isMiddle }) {
      if (isMiddle) {
        window.open(`/#/setup/keyboards/${row.id}`, '_blank')
      } else {
        const res = await this.$refs.dialog.open(row.id)
        if (res === 'RELOAD') this.$refs.report.reload()
      }
    },

    async confirmDelete() {
      let res = await this.$confirmDeactivate({
        strings: 'teclado;o',
        len: this.selectedIds.length
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await Keyboard.delete(id)
          }
          this.selectedIds = []
          this.$snack('Desativado(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
